import { endpoints } from "../endpoints";
import { instance } from "../config";
export var sentFile = function sentFile(binaryImg) {
  return instance.post(endpoints.file.sent, binaryImg);
};
export var getBlobFile = function getBlobFile(url) {
  return instance.get(url, {
    responseType: 'arraybuffer'
  }).then(function (response) {
    return new Blob([response.data], {
      type: response.headers['content-type']
    });
  });
};